// Dependecies
import React from 'react'

const CourseParticipants = (props) => {
  return (
    <tbody>
        {props.courseParticipants.map((person) => (
        <tr key={person.id} className=''>
            <td className='py-2 px-4'>{person.full_Name}</td>
            <td className='py-2 px-4'>{person.email}</td>
            <td className='py-2 px-4'>{person.position}</td>
            <td className='py-2 px-4 text-center'>
            <button className='cursor-pointer' onClick={() => props.handleDeleteCourseParticipant(props.openModals.find(modal => modal.modalID === 'adminViewCourseParticipantsModal')?.senderID, person.id)}>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#f56565" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-x-square"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"/><line x1="9" y1="9" x2="15" y2="15"/><line x1="15" y1="9" x2="9" y2="15"/></svg>
            </button>
            </td>
        </tr>
        ))}
    </tbody>
  )
}

export default CourseParticipants